import { render, staticRenderFns } from "./win.vue?vue&type=template&id=7a36b184&scoped=true"
import script from "./win.vue?vue&type=script&lang=js"
export * from "./win.vue?vue&type=script&lang=js"
import style0 from "./win.vue?vue&type=style&index=0&id=7a36b184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36b184",
  null
  
)

export default component.exports